import { trackEvent } from "@/lib/dataLayer";
import {
  STORES_OPTIONS,
  type DemoLeadValues,
} from "@/pages/landingPage/constants/demoLead";
import { WHATSAPP_PHONE } from "@/pages/landingPage/utils/whatsapp";
import { useDemoWelcomeStore } from "@/store/demoWelcomeStore";
import { phoneUtils } from "@/utils";

/**
 * Envia o lead de demo para /api/lead (e-mail, Discord e CRM), conta a
 * conversão (`form_submit_demo`) e guarda o lead para a LP de boas-vindas.
 * Lança erro se a API falhar; quem chama mostra o aviso e navega para
 * `/boas-vindas` no sucesso.
 *
 * `source` vai para o e-mail e o CRM para separar de qual form o lead veio.
 */
export const useSendDemoLead = (source: string) => {
  const setWelcomeLead = useDemoWelcomeStore(state => state.setLead);

  return async (data: DemoLeadValues) => {
    const storesLabel =
      STORES_OPTIONS.find(o => o.value === data.storesRange)?.label ??
      data.storesRange;
    const cleanedPhone = phoneUtils.cleanPhoneNumber(data.phone);

    const response = await fetch("/api/lead", {
      method: "POST",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        name: data.name,
        company: data.company,
        phone: cleanedPhone,
        storesRange: data.storesRange,
        storesLabel,
        source,
        honeypot: data.honeypot,
      }),
    });

    if (!response.ok) {
      throw new Error(`lead_send_failed_${response.status}`);
    }

    trackEvent({
      event: "form_submit_demo",
      stores_range: data.storesRange,
    });

    const message = [
      `Olá! Quero agendar uma demo da Fidexa.`,
      ``,
      `Nome: ${data.name}`,
      `Empresa: ${data.company}`,
      `Telefone: ${cleanedPhone}`,
      `Tamanho da rede: ${storesLabel}`,
    ].join("\n");

    // O WhatsApp abre pelo botão da LP de boas-vindas, num clique do
    // visitante: o `window.open` depois do `await` caía no bloqueio de pop-up.
    setWelcomeLead({
      name: data.name.trim(),
      company: data.company.trim(),
      storesLabel,
      phone: data.phone,
      submittedAt: new Date().toISOString(),
      whatsappUrl: `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(message)}`,
    });
  };
};
